import { isUndefined, memoize } from 'lodash';
import React from 'react';
import { EmptyCell } from 'components/atoms/empty-cell';
import { EstDueDate } from 'components/molecules/inferred-progress-days';

export const estDueDate = memoize((ipDays: number | undefined) => {
  if (!isUndefined(ipDays)) {
    return <EstDueDate count={ipDays} />;
  }

  return <EmptyCell />;
});
